export const API_HOST = 'https://back66.ruptly.tv/api/v1';
export const WS_URI = 'wss://back66.ruptly.tv/cable';
export const TUS_URI = 'https://back66.ruptly.tv/files';
